module.exports = __webpack_public_path__ + "static/media/book_asrar_ae_khudi_persian_5.7ce6a444.jpg";